(function () {
  var STORAGE_KEY = 'kc_recently_viewed';
  var MAX_ITEMS = 12;

  /* ── Storage helpers ── */

  function load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage quota exceeded — best effort */
    }
  }

  /* ── Public API ── */

  function trackProduct(handle, title, image, price, url) {
    if (!handle) return;
    var items = load().filter(function (i) { return i.handle !== handle; });
    items.unshift({
      handle: handle,
      title: title,
      image: image,
      price: price,
      url: url,
      viewed_at: new Date().toISOString()
    });
    if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
    save(items);
  }

  function getRecentlyViewed(excludeHandle) {
    var items = load();
    if (excludeHandle) {
      items = items.filter(function (i) { return i.handle !== excludeHandle; });
    }
    return items;
  }

  /* Remove a stale entry whose cached image URL no longer resolves
     (product archived or image replaced), then drop its card. */
  function removeDeadEntry(img) {
    var card = img.closest('[data-rv-card]');
    var handle = card ? card.getAttribute('data-rv-card') : '';
    if (handle) {
      save(load().filter(function (i) { return i.handle !== handle; }));
    }
    if (card) {
      var grid = card.parentElement;
      card.remove();
      if (grid && grid.children.length < 1) {
        var container = document.getElementById('kc-recently-viewed');
        if (container) container.style.display = 'none';
      }
    }
  }

  /* ── HTML escaping ── */

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ── Render recently viewed cards ── */

  function render() {
    var container = document.getElementById('kc-recently-viewed');
    if (!container) return;

    var currentHandle = container.getAttribute('data-current-handle') || '';
    var items = getRecentlyViewed(currentHandle);

    if (items.length < 1) {
      container.style.display = 'none';
      return;
    }

    /* Show max 8 in the grid */
    var show = items.slice(0, 8);

    var html =
      '<div class="mx-auto max-w-[var(--container-rb)] px-4 md:px-8 pt-8 pb-10">' +
        '<h2 class="headline text-lg sm:text-xl mb-4">Recently Viewed</h2>' +
        '<div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">';

    show.forEach(function (item) {
      var priceNum = item.price ? Number(String(item.price).replace(/[,$]/g, '')) : 0;
      var priceDisplay = priceNum ? '$' + priceNum.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';

      html +=
        '<a class="group block border border-rb-rule-light hover:border-rb-ink transition-colors" data-rv-card="' + escapeHtml(item.handle) + '" href="' + escapeHtml(item.url) + '">' +
          '<div class="relative aspect-[4/3] p-[10%]">' +
            '<div class="relative h-full w-full">' +
              (item.image
                ? '<img alt="' + escapeHtml(item.title) + '" loading="lazy" decoding="async" class="object-contain" style="position:absolute;height:100%;width:100%;left:0;top:0;right:0;bottom:0;color:transparent" src="' + escapeHtml(item.image) + '" width="640" height="480" onerror="KCRecentlyViewed.removeDeadEntry(this)">'
                : '') +
            '</div>' +
          '</div>' +
          '<div class="border-t-4 border-rb-rule px-2.5 pb-2.5 pt-2 sm:px-4 sm:pb-4 sm:pt-2.5">' +
            '<h3 class="headline text-[11px] sm:text-base leading-tight truncate">' + escapeHtml(item.title) + '</h3>' +
            (priceDisplay
              ? '<div class="mt-1"><span class="font-mono text-[13px] sm:text-[15px] font-bold text-rb-red">' + escapeHtml(priceDisplay) + '</span></div>'
              : '') +
          '</div>' +
        '</a>';
    });

    html += '</div></div>';
    container.innerHTML = html;
    container.style.display = '';
  }

  /* ── Auto-track on PDP ── */

  function autoTrack() {
    var el = document.querySelector('[data-rv-track]');
    if (!el) return;
    trackProduct(
      el.getAttribute('data-rv-handle'),
      el.getAttribute('data-rv-title'),
      el.getAttribute('data-rv-image'),
      el.getAttribute('data-rv-price'),
      el.getAttribute('data-rv-url')
    );
  }

  /* ── Init ── */

  function init() {
    autoTrack();
    render();
  }

  /* Expose public API */
  window.KCRecentlyViewed = {
    trackProduct: trackProduct,
    getRecentlyViewed: getRecentlyViewed,
    removeDeadEntry: removeDeadEntry
  };

  document.addEventListener('DOMContentLoaded', init);
})();
